import {
  useStyle 
} from "@/classify";
import React from "react";
import defaultClasses from "./richContent.module.css";
import richContentRenderers from "./richContentRenderers";

/**
 * RichContent component.
 *
 * This component serves as the pool to determine which type of content is being rendered
 * and pass the data off to the correct system.
 *
 * @typedef RichContent
 * @kind functional component
 *
 * @param {Object} props React component props
 *
 * @returns {React.Element} A React component that renders Heading with optional styling properties.
 */
const RichContent = (props: any) => {
  const classes = useStyle(defaultClasses, props.classes);
  const rendererProps = {
    ...props,
    classes
  };

  for (const Renderer of richContentRenderers) {
    const {
      Component, canRender 
    } = Renderer;

    if (canRender(rendererProps.html)) {
      return <Component {...rendererProps} />;
    }
  }

  return null;
};

export default RichContent;
